import './process-polyfill'
import React from 'react'
import ReactDOM from 'react-dom'
import { Provider } from 'react-redux'
import { App } from './App'
import register from './registerServiceWorker';
import store from './store/configureStore'
import ErrorBoundary from './componentes/ErrorBoundary'
import './interceptors/requestResponseLoadingInterceptors'
import './interceptors/responseErrorInterceptors';
import './interceptors/axiosResquestInterceptor'

import jwtInterceptor from './interceptors/authenticationJwtInterceptors'
import { recuperarAmbiente } from './util/ambienteActions';
import { inicializarEventosSyncOffline } from './util/offlineSyncManager';
import { inicializarEventosSyncOfflineVendaUrbana } from './util/offlineSyncManagerVendaUrbana';
import { inicializarEventosSyncOfflineEncomendaAvulsa } from './util/offlineSyncManagerEncomendaAvulsa';
import { setOnline, setOffline } from './actions/util/conexaoActions';

store.dispatch(recuperarAmbiente());

jwtInterceptor(store);
inicializarEventosSyncOffline(store.dispatch);
inicializarEventosSyncOfflineVendaUrbana(store.dispatch);
inicializarEventosSyncOfflineEncomendaAvulsa(store.dispatch);

window.addEventListener('online', () => store.dispatch(setOnline()));
window.addEventListener('offline', () => store.dispatch(setOffline()));

export default ReactDOM.render(
  <ErrorBoundary>
    <Provider store={store}>
      <App/>
    </Provider>
  </ErrorBoundary>,
  document.getElementById('root')
)

register();
